var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "slider",
    staticClass: "slider-container",
    on: {
      "mousedown": _vm.startDrag,
      "touchstart": _vm.startDrag
    }
  }, [_c('div', {
    staticClass: "slider-bar"
  }, [_c('div', {
    staticClass: "slider-fill",
    style: {
      width: _vm.filledWidth + 'px'
    }
  })]), _c('div', {
    staticClass: "slider-thumb",
    style: {
      left: _vm.thumbPosition - _vm.thumbOffset + 'px'
    }
  }), _c('div', {
    staticClass: "slider-tooltip",
    style: {
      left: _vm.thumbPosition - 10 + 'px'
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/icon/icon-star.png'),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.currentValue.stars) + " ")]), _vm._l(_vm.marks, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "slider-mark",
      style: {
        left: item.position - _vm.thumbOffset + 'px'
      }
    }, [_c('div', {
      staticClass: "mark-thumb",
      style: {
        background: Number(_vm.currentValue.multiple) >= Number(item.multiple) ? '#fed629' : '#21252d'
      }
    }), _c('span', {
      staticClass: "mark-label",
      style: {
        color: item.color
      }
    }, [_vm._v("x " + _vm._s(item.multiple))])]);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };